<template>
  <div class="form-step">
    <ion-grid class="form-step-content">
      <ion-row>
        <ion-col>
          <h1 class="form-question">
            Identify the machine that you are performing the inspection on.
          </h1>
        </ion-col>
      </ion-row>
      <template v-if="code">
        <ion-row>
          <ion-col>
            {{ code }}
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-button fill="clear" expand="block" @click="code = undefined"
            >Change Code</ion-button
          >
        </ion-row>
      </template>
      <template v-else>
        <ion-row>
          <ion-col>
            <div>
              <ion-button expand="block" @click="openCodeScanner">
                <ion-icon slot="start" name="qr-scanner"></ion-icon>
                Scan QR Code
              </ion-button>
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <template v-if="isManualCode">
              <ion-item>
                <ion-input
                  type="number"
                  inputmode="numeric"
                  placeholder="Enter 8-digit code"
                  :value="manualCode"
                  @input="manualCode = $event.target.value"
                ></ion-input>
              </ion-item>
              <div class="ion-padding">
                <ion-button
                  v-if="manualCode && manualCode.length === 8"
                  @click="code = manualCode"
                  expand="block"
                  fill="clear"
                  >Enter</ion-button
                >
                <ion-button
                  v-else
                  @click="isManualCode = false"
                  expand="block"
                  fill="clear"
                  >Cancel</ion-button
                >
              </div>
            </template>
            <template v-else>
              <ion-button
                fill="clear"
                expand="block"
                @click="isManualCode = true"
                >Enter Code Manually</ion-button
              >
            </template>
          </ion-col>
        </ion-row>
      </template>
      <ion-row v-if="message">
        <ion-col>
          <slot name="invalid">
            <ion-chip color="danger">
              <ion-label>{{ message }}</ion-label>
            </ion-chip>
          </slot>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</template>

<script>
import QRCodeScannerModal from "../../components/QRCodeScannerModal.vue";

export default {
  name: "StepAsset",
  props: ["value", "data", "message"],
  data() {
    return {
      isManualCode: false,
      manualCode: undefined
    };
  },
  computed: {
    code: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    openCodeScanner() {
      this.isManualCode = false;
      const onCode = function(value) {
        this.code = value;
      }.bind(this);
      return this.$ionic.modalController
        .create({
          component: QRCodeScannerModal,
          componentProps: {
            propsData: {
              onCode
            }
          }
        })
        .then(modal => modal.present());
    }
  }
};
</script>
